import React from 'react';
import Iconfont from '@/components/Iconfont/Iconfont';
import {Link} from 'react-router';
import {Layout, Spin} from 'antd';
import {BizNavbarMenu} from './CkMenu'
import CkNavbar from '@/components/CkNavbar';
import {bindActionCreators} from "redux";
import {fetchCMEnums} from "../../redux/actions/cmenums";
import {connect} from "react-redux";

const {Header} = Layout;


class CkLayout extends React.Component {

    componentDidMount() {
        if (!this.props.cmEnums || !this.props.cmEnums.data)
            this.props.fetchCMEnums();
    }

    render() {
        if(!this.props.cmEnums || !this.props.cmEnums.data){
            return <Spin className="full-screen-spin" spinning={true}/>
        }



        const moduleName = this.props.routes && this.props.routes.length > 3 ? this.props.routes[3].path : "";

        const navbarBrand1 =
            <a className="navbar-brand white-logo" href="/"></a>;

        const navbarBrand2 =
            <Link to={'/admin'} className="navbar-toggle">
                <Iconfont libname="ckicon" type="apps"/>
            </Link>;

        const navbarMenu =
            <BizNavbarMenu selectedKey={this.props.routes.slice(1, 4).map(r => r.path).join("/")}/>


        if (this.props.children) {
            return ( <Layout className={"ck-layout-wrapper ck-module ck-module-" + moduleName}>
                    <Header>
                        <CkNavbar
                            navbarHeader={moduleName ? navbarBrand2 : navbarBrand1}
                        />
                    </Header>
                    {this.props.children}
                </Layout>
            )
        }


        var clonedNavbarMenuMoreProps = this.props.navbarMenu ? React.cloneElement(
            this.props.navbarMenu,
            {
                selectedKey: this.props.routes.slice(1, 4).map(r => r.path).join("/"),
            }
        ) : null;

        var clonedSiderMenuWithMoreProps = this.props.main ? React.cloneElement(
            this.props.main,
            {
                siderMenu: this.props.siderMenu,
            },
        ) : null;

        return (
            <Layout className={"ck-layout-wrapper ck-module ck-module-" + moduleName}>
                <Header>
                    <CkNavbar
                        navbarTitle={this.props.routes.length > 3 ? this.props.routes[3].title : ''}
                        navbarHeader={moduleName ? navbarBrand2 : navbarBrand1}
                        navbarMenu={clonedNavbarMenuMoreProps}
                    />
                </Header>
                {clonedSiderMenuWithMoreProps}
            </Layout>
        )
    }
}

const mapStateToPorps = state => {
    const cmEnums = state.cmEnums;
    return {cmEnums};
};
const mapDispatchToProps = dispatch => ({
    fetchCMEnums: bindActionCreators(fetchCMEnums, dispatch),
});

export default connect(mapStateToPorps, mapDispatchToProps)(CkLayout);




// WEBPACK FOOTER //
// ./src/components/ck/CkLayout.jsx